import axios from 'axios';
import { API_BASE_URL, AUTH_TOKEN_KEY } from 'constants/index';
import { useState } from 'react';

export const usePostUserConsignment = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const post = async (payload) => {
    setIsLoading(true);

    const response = await axios
      .post(`${API_BASE_URL}/users/consignments`, payload, {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY),
        },
      })
      .then((res) => {
        if(res.data?.status_code !== 200){
          return {
            isSuccess: false,
            message: res.data?.data?.message,
            data: res.data?.data
          }
        }

        return {
          isSuccess: true,
          message: 'Consignment Request Success',
          data: res.data?.data,
        };
      })
      .catch((err) => {
        return {
          isSuccess: false,
          message: "Failed to consign, please try again later or contact our support",
          data: null,
        };
      });

    setIsLoading(false);
    return response;
  };

  return {
    isLoading,
    post,
  };
};
